

export const config = {
  method: 'get',
  url: 'https://dev.to/api/articles?username=theallegrarr',
  headers: { 
    'Content-Type': 'application/json'
  }
};